const FILES_BASE_URL = (import.meta.env.VITE_FILES_BASE_URL ?? '').replace(/\/$/, '')

export function staticAssetUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`
  return FILES_BASE_URL ? `${FILES_BASE_URL}/files${normalized}` : normalized
}

export const BRAND_LOGO = staticAssetUrl('/static/shared/logo.png')
// Existing published key, also consumed by Customer. Keep the URL stable.
export const CHEF_AVATAR_PLACEHOLDER = staticAssetUrl('/static/customer-app/assets/empty-states/chef.png')
